export const N8N_WEBHOOK_URL = "/webhook/7984c83c-163d-4016-a030-dbae4842e3a5";
